import { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";

import { faPlus } from "@fortawesome/pro-light-svg-icons";

import { Icon, PermissionCheck } from "@/components";

import { PermissionRoles } from "@/enum";

import { ButtonColor, ButtonSize } from "@/components/Button/types";
import { Button } from "@/components/Button/Button";

import { usePageTitle } from "@/utils/usePageTitle";

import { CompaniesTable } from "../../components/CompaniesTable";
import { CreateCompaniesModal } from "../../components/CreateCompaniesModal";

export const CompaniesOverview: FunctionComponent = () => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`companies.${key}`);
	const [isInviteModalOpen, setIsInviteModalOpen] = useState<boolean>(false);

	usePageTitle(ts("title"));

	return (
		<div className="sm:block flex flex-col items-start justify-between p-6">
			<div className="flex items-end justify-end w-full mb-8">
				<div className="flex justify-between w-full">
					<div>
						<h2 className={"text-[20px] mt-3 font-semibold leading-6 text-primary-blue-dark"}>
							{ts("search-by-organization")}
						</h2>
						<p className="mt-[6px] text-primary-gray-lighter text-[14px] leading-5">
							{ts("search-by-organization-description")}
						</p>
					</div>
					<PermissionCheck requiredPermissions={[PermissionRoles.COMPANY]}>
						<Button
							className="!w-fit !min-h-[44px] !text-[14px] !font-[500]"
							color={ButtonColor.ACTION}
							image={
								<div className="mr-2">
									<Icon className="w-5 h-5" icon={faPlus} />
								</div>
							}
							size={ButtonSize.S}
							testId="new-user-button"
							title={ts("create.button")}
							onClick={() => setIsInviteModalOpen(true)}
						/>
					</PermissionCheck>
				</div>
			</div>

			{<CompaniesTable />}

			{isInviteModalOpen && (
				<CreateCompaniesModal isOpen={isInviteModalOpen} setIsOpen={setIsInviteModalOpen} />
			)}
		</div>
	);
};
